import type { FocusCohort } from "./patterns.api";

const COHORTS = new Set<FocusCohort>(["bullet", "blitz", "rapid", "daily"]);

export type PatternNavigation =
  { step: "format"; cohort: null; motif: null } | { step: "workspace"; cohort: FocusCohort; motif: string | null };

const motifFrom = (value: string | null): string | null =>
  value && value.length <= 80 && /^(?:(?:principle|moment|insight):)?[\p{L}\p{N}_ -]+$/u.test(value) ? value : null;

/** The selected explorer item, independent of whether the URL names a format. */
export const patternIdFrom = (params: URLSearchParams): string | null => motifFrom(params.get("patternId"));

/** Changes only the selection; touching `format` would rebuild the performance selection. */
export const withPatternId = (params: URLSearchParams, id: string | null): URLSearchParams => {
  const next = new URLSearchParams(params);
  if (id) next.set("patternId", id);
  else next.delete("patternId");
  return next;
};

export const parsePatternNavigation = (params: URLSearchParams): PatternNavigation => {
  const format = params.get("format");
  if (!format || !COHORTS.has(format as FocusCohort)) return { step: "format", cohort: null, motif: null };
  return { step: "workspace", cohort: format as FocusCohort, motif: motifFrom(params.get("patternId")) };
};

export const patternWorkspaceUrl = (cohort: FocusCohort, motif?: string | null, current?: URLSearchParams): string => {
  void current;
  const params = new URLSearchParams();
  params.set("format", cohort);
  const safeMotif = motifFrom(motif ?? null);
  if (safeMotif) params.set("patternId", safeMotif);
  return `/patterns?${params.toString()}`;
};
